import React, { useState } from "react";
import axios from "axios";
import * as S from "./ValidarCpfStyle";

export default function ValidarCpf() {
  const [type, setType] = useState("cpf");
  const [document, setDocument] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState(null);

  const handleValidate = async () => {
    setLoading(true);
    setResult(null);
    const token = "182513820MfqwAgtRve329523168";
    const cleanedDoc = document.replace(/\D/g, "");

    try {
      const url = `https://ws.hubdodesenvolvedor.com.br/v2/${type}/?${type}=${cleanedDoc}&token=${token}`;
      const response = await axios.post(url);

      if (response.data.status) {
        setResult({ success: true, data: response.data.result });
      } else {
        setResult({
          success: false,
          message: response.data.return || "Documento inválido.",
        });
      }
    } catch (error) {
      setResult({
        success: false,
        message: "Erro ao conectar com o serviço de validação.",
      });
    } finally {
      setLoading(false);
    }
  };

  return (
    <S.Container>
      <S.ValidationCard>
        <h2>Validação Oficial</h2>

        <S.SelectType>
          <button
            className={type === "cpf" ? "active" : ""}
            onClick={() => {
              setType("cpf");
              setDocument("");
              setResult(null);
            }}
          >
            CPF
          </button>
          <button
            className={type === "cnpj" ? "active" : ""}
            onClick={() => {
              setType("cnpj");
              setDocument("");
              setResult(null);
            }}
          >
            CNPJ
          </button>
        </S.SelectType>

        <S.InputGroup>
          <label>Digite o {type.toUpperCase()}</label>
          <input
            type="text"
            placeholder={
              type === "cpf" ? "000.000.000-00" : "00.000.000/0000-00"
            }
            value={document}
            onChange={(e) => setDocument(e.target.value)}
          />
        </S.InputGroup>

        <S.ActionButton
          onClick={handleValidate}
          disabled={loading || !document}
        >
          {loading ? "Validando..." : "Consultar Receita Federal"}
        </S.ActionButton>

        {result && (
          <S.ResultBox success={result.success}>
            <strong>
              {result.success ? "✅ Documento Válido" : "❌ Falha na Validação"}
            </strong>
            {result.success ? (
              <pre>
                Nome: {result.data.nome || result.data.nome_da_pf} {"\n"}
                Situação:{" "}
                {result.data.situacao || result.data.situacao_cadastral} {"\n"}
                Data: {result.data.abertura || result.data.data_nascimento}
              </pre>
            ) : (
              <p>{result.message}</p>
            )}
          </S.ResultBox>
        )}
      </S.ValidationCard>
    </S.Container>
  );
}
